var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.2,
    cy: 7.2,
    r: 7.2,
    fill: "#2386ee",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.3,
    cy: 7.3,
    r: 4.1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.3,
    cy: 7.3,
    r: 2.7,
    fill: "#2386ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationPin);
export default __webpack_public_path__ + "static/media/current-location-pin.7dbefef7ebf3ab19252c4ef0cd37bed8.svg";
export { ForwardRef as ReactComponent };